// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"ae327328","453":"44f36e88","455":"7a07f2ae","771":"b5fad7e4","818":"bcf4d5f2"}[chunkId] + ".chunk.js";
};